<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 
         

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('paterno')">
          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            Información de Residencia Fiscal del {{title}}
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>
          </md-card-content> 
        </md-card> 

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('pais')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            País de Residencia Fiscal *
          </md-card-header>
          <md-card-content>

            <div>    

              <ejs-dropdownlist ref="pa"  v-model="form.pais" 
              placeholder='Seleccione' 
              popupHeight='250px' sortOrder="Ascending" 
              :allowFiltering='allowFiltering' 
              :filtering='filtering' 
              :dataSource='pais' 
              :fields='fields'/>              


              <div class="radioform" :class="getValidationClass('pais')">
                <span class="md-error" v-if="!$v.form.pais.required">Su respuesta es obligatoria.</span>
              </div>

            </div>
          </md-card-content> 
        </md-card>             

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('tipoidentifaciontributaria')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Tipo de Identificación Tributaria *
          </md-card-header>
          <md-card-content>
                      
            <div v-for="(value, i) in item" :key="i" class="md-layout-item md-layout md-size-100 md-alignment-center-left">
              <div class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-5 md-xsmall-size-10">
                <md-checkbox v-model="form.tipoidentifaciontributaria" :value="value" />
              </div>
              <div class="md-layout-item md-xlarge-size-95 md-large-size-95 md-medium-size-90 md-small-size-95 md-xsmall-size-90">
                <p class="justify">
                  {{value}}
                </p>
              </div>
            </div>                   

              <div class="radioform" :class="getValidationClass('tipoidentifaciontributaria')">
                <span class="md-error" v-if="!$v.form.tipoidentifaciontributaria.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>  

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nroidentifaciontributaria')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Nº Identificación Tributaria *
          </md-card-header>
          <md-card-content>

            <div>            
              <md-field :class="getValidationClass('nroidentifaciontributaria')">
                <md-input type="text" id="paterno" name="paterno" placeholder="Su respuesta" v-model="form.nroidentifaciontributaria"  autocomplete="off"/>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>                  

        <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>  

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
import {
  required,
//   minLength,
//   numeric,
} from 'vuelidate/lib/validators'

import { Query } from "@syncfusion/ej2-data";


export default {
  mixins: [validationMixin],
  name: 'Item4',
  props: ["title", "pais"],
  data: () => ({
    form:{
    },
    item:[
        "NIT (Número de Identificación Tributaria)",
        "GIIN",
        "Número tributario equivalente del país",
        "No cuento con ninguna de las opciones anteriores"
    ],
    query : new Query().select(['nacionalidad', 'idPais']).take(7),
    fields : { text: 'nacionalidad', value: 'nacionalidad' },
    allowFiltering: true,      
  }),

  mounted: function(){
    this.form = this.$store.state.item.item4
    //this.$store.dispatch("back", false);
  },
  validations(){
    var validate = {
      form: {
        pais: {required},
        tipoidentifaciontributaria: {required,},
      },          
    }
    return validate;
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item4
    },       
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.$emit('setSaveForm', {id:"4", form: this.form, index: "5"});
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    filtering: function(e) {
      var searchData = this.pais
      console.log(searchData)
      var query = new Query();
      //frame the query based on search string with filter type.
      query = (e.text != "") ? query.where("nacionalidad", "startswith", e.text, true) : query;
      //pass the filter data source, filter query to updateData method.
      console.log(query)
      //e.updateData(searchData, query);
    }      
     
  },
  computed: {
   
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
